import { relations } from 'drizzle-orm'
import { AnyPgColumn, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { visits } from './visit'

export const invoiceStatusEnum = pgEnum('invoice_status', [
  'finalized',
  'sent',
  'paid',
  'void',
])

export const invoices = pgTable(
  'invoices',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    stripeInvoiceId: text().notNull().unique(),
    invoiceNumber: text().notNull(),
    referenceNumber: text().notNull().unique(),
    totalAmount: getMonetaryField().notNull(),
    status: invoiceStatusEnum().notNull().default('finalized'),
    sentAt: getTimestampWithTimezone(),
    paidAt: getTimestampWithTimezone(),
    voidedAt: getTimestampWithTimezone(),
    voidReason: text(),
    voidsInvoiceId: getNullableIdReference((): AnyPgColumn => invoices.id),
  },
  (table) => getBaseIndexes('invoices', table),
)

export const invoicesRelations = relations(invoices, ({ one }) => ({
  visit: one(visits, {
    fields: [invoices.visitId],
    references: [visits.id],
  }),
  voidedInvoice: one(invoices, {
    fields: [invoices.voidsInvoiceId],
    references: [invoices.id],
    relationName: 'invoiceRevision',
  }),
}))
